import { Spin } from "antd";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FormulaForm } from "@/pages/Settings/Formula/FormulaForm";
import FormulasTable from "@/pages/Settings/Formula/FormulasTable";

export const AssignedDeviceFormula = ({
  deviceFormulas,
  deviceParameters,
  deleteFormula = () => {},
  refetchFormula = () => {},
  isLoading = false,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedFormula, setSelectedFormula] = useState();

  const onFinish = () => {
    handleCancelModal();
    refetchFormula();
  };

  const handleEdit = (row) => {
    setSelectedFormula(row);
    setShowModal(true);
  };

  const handleCancelModal = () => {
    setShowModal(false);
    setSelectedFormula();
  };

  return (
    <>
      <h5 className="mt-3">Assigned Device Formulas</h5>

      <Spin spinning={isLoading}>
        <div className="row">
          <FormulasTable
            showPeriodAndFallback
            formulas={deviceFormulas}
            onDeleteRow={(row) => deleteFormula(row._id)}
            onEditRow={handleEdit}
          />
        </div>
      </Spin>
      <Modal
        show={showModal}
        style={{ width: "100%" }}
        centered
        className="col-md-12"
        size="xl"
        onHide={handleCancelModal}
      >
        <Modal.Body>
          <FormulaForm
            assignFormula
            parameters={deviceParameters.map((p) => ({
              name: `${p.name} (${p?.device?.site?.name} > ${p?.device?.name})`,
              value: `${p.name} (${p?.device?.site?.name} > ${p?.device?.name})`,
              _id: p._id,
            }))}
            mode={selectedFormula ? "edit" : "create"}
            data={selectedFormula}
            onFinish={onFinish}
            onCancel={handleCancelModal}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

AssignedDeviceFormula.propTypes = {
  deviceFormulas: PropTypes.array,
  deviceParameters: PropTypes.array,
  deleteFormula: PropTypes.func,
  refetchFormula: PropTypes.func,
  isLoading: PropTypes.bool,
};
